import { render } from "./CGridMenuColumn.vue?vue&type=template&id=3b871290&scoped=true"
import script from "./CGridMenuColumn.vue?vue&type=script&lang=js"
export * from "./CGridMenuColumn.vue?vue&type=script&lang=js"

import "./CGridMenuColumn.vue?vue&type=style&index=0&id=3b871290&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b871290"]])

export default __exports__